import React, { Component } from 'react';
import * as game from '../../controllers';
import { Rollbar } from '@app-masters/js-lib';
import { push } from 'react-router-redux';
import { connect } from 'react-redux';
import Spinner from '../components/spinner';
import errorCatcher from '../../utils/errorCatcher';

class Ranking extends Component {
    constructor (props) {
        super(props);
        this.state = {
            ranking: null,
            selectedSchool: null,
            loading: false,
            school: null,
            global: true
        };
        this.renderRankingList = this.renderRankingList.bind(this);
    }

    componentDidMount () {
        this.setState({loading: true});
        game.ranking.getFullRanking().then(response => {
            this.setState({
                ranking: response,
                loading: false
            });
        }).catch((err) => errorCatcher(err));
        let user = JSON.parse(window.localStorage.getItem('user'));
        if (!user) {
            // err, message, payload, callback)
            Rollbar.error(new Error('user not found in localStorage at ranking.js'), 'user not found in localStorage at ranking.js', window.localStorage);
            // throw new Error('user not found in localStorage at ranking.js');
            return;
        }
        this.setState({
            school: user.data.school ? user.data.school._id : null,
            schoolName: user.data.school ? user.data.school.name : ''
        });
    }

    renderRankingList (ranking) {
        let rankingRender = ranking.map((rank, index) => {
            // console.log(rank.positionSchool);
            let rankName = (rank.userName ? rank.userName : 'Nameless User');
            let rankPoint = rank.points;
            let rankPosition = this.state.global ? rank.positionGlobal : rank.positionSchool;
            if (rank.userId === this.props.userItem.id) {
                rankName = (<b>{rankName}</b>);
                rankPoint = (<b>{rankPoint}</b>);
                rankPosition = (<b>{rankPosition}</b>);
            }

            return (
                <div
                    key={index}
                    onClick={() => this.props.push(`/user/${rank.userId}`)}
                    className='ranking-list-item'
                >
                    <div>{rankPosition}</div>
                    <div>{rankName}</div>
                    <div>{rankPoint}</div>
                </div>
            );
        });

        if (rankingRender.length > 10) {
            // console.log(rankingRender);
            const user = rankingRender.pop();
            // console.log(rankingRender);
            rankingRender.push(
                <div
                    style={{textAlign: 'center'}}
                    key={rankingRender.length + 1}
                    className='ranking-list-item'>
                    <div>•••</div>
                </div>
            );
            // console.log(rankingRender);
            rankingRender.push(user);
            // console.log(rankingRender);
        }
        return rankingRender;
    }

    onSchoolSelectChange (value) {
        let global = value === '';
        this.setState({global});
        this.setState({loading: true});
        game.ranking.getFullRanking(value).then(response => {
            this.setState({ranking: response});
            this.setState({loading: false});
        }).catch((err) => errorCatcher(err));
    }

    render () {
        const ranking = this.state.ranking;

        return (
            <div className='browser ranking flex'>
                <div className='fixed'>
                    <div className='window-buttons'>
                        <div onClick={() => this.props.push('/')}
                            className='btn-circle'
                        />
                        <div onClick={() => this.props.push('/')}
                            className='btn-circle'
                        />
                        <div onClick={() => this.props.push('/')}
                            className='btn-circle'
                        />
                    </div>
                    <div className='browser-address-bar padding'>
                        <span className='rounded-input'>RANKING</span>
                    </div>
                </div>

                {
                    (this.state.loading)
                        ? <Spinner />
                        : <div>
                            {
                                this.state.school
                                    ? <div className='ranking-button-wrapper'>
                                        <div
                                            className={'btn flat ' + (this.state.global ? 'current' : null)}
                                            onClick={() => {
                                                this.onSchoolSelectChange('');
                                            }}
                                        >
                                            Ranking Geral
                                        </div>
                                        <div
                                            className={'btn flat ' + (!this.state.global ? 'current' : null)}
                                            onClick={() => {
                                                this.onSchoolSelectChange(this.state.school);
                                            }}
                                        >
                                            {
                                                this.state.schoolName
                                            }
                                        </div>
                                    </div>
                                    : null
                            }
                            <div className='ranking-wrapper'>
                                <div className='ranking-header'>
                                    <div>Pos</div>
                                    <div>Jogador</div>
                                    <div>Pts</div>
                                </div>
                                {
                                    ranking
                                        ? <div>{this.renderRankingList(ranking)}</div>
                                        : null
                                }
                            </div>
                        </div>
                }

            </div>
        );
    }
}

const mapStateToProps = ({user}) => {
    const userItem = user.user;
    return {userItem};
};

export default connect(mapStateToProps, {push})(Ranking);



// WEBPACK FOOTER //
// ./src/views/rankingView/ranking.js